import mixpanel from 'mixpanel-browser';

const MAX_QUEUED_EVENTS = 100;

interface QueuedEvent {
  eventType: string;
  data: Record<string, unknown>;
}

let analyticsUser: string | undefined;
let userResolutionComplete = false;
let queuedEvents: QueuedEvent[] = [];
let mixpanelClient: typeof mixpanel | undefined;

const sendEvent = (eventType: string, data: Record<string, unknown>) => {
  if (!analyticsUser) {
    return;
  }

  if (!mixpanelClient) {
    mixpanel.init('ceb13a2e1ba28a245cddb750352b1257', {
      api_host: 'https://platform-signals.meisterplan.in',
      api_routes: {
        track: 'signal',
        engage: 'meta',
      },
      ignore_dnt: true,
    });
    mixpanel.identify(analyticsUser);
    mixpanelClient = mixpanel;
  }

  mixpanelClient.track(eventType, data);
};

export const setAnalyticsUser = (itdId: string | undefined) => {
  userResolutionComplete = true;
  analyticsUser = itdId?.trim().toLowerCase() || undefined;

  if (!analyticsUser) {
    queuedEvents = [];
    return;
  }

  if (mixpanelClient) {
    mixpanelClient.identify(analyticsUser);
  }

  const eventsToSend = queuedEvents;
  queuedEvents = [];
  eventsToSend.forEach(({ eventType, data }) => sendEvent(eventType, data));
};

export const trackAnalytics = (eventType: string, data: Record<string, unknown> = {}) => {
  if (analyticsUser) {
    sendEvent(eventType, data);
    return;
  }

  if (!userResolutionComplete) {
    queuedEvents = [...queuedEvents.slice(-(MAX_QUEUED_EVENTS - 1)), { eventType, data }];
  }
};
